import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import SearchPackage from "components/SearchPackage/SearchPackage";
import SearchedPackageDetails from "components/SearchedPackageDetails/SearchedPackageDetails";
import { PrimaryButton } from "widgets";
import { usePackageDetails, usePackageVersion } from "store/backend/apiHooks";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Loader from "shared/Loader/Loader";

import styles from "./PackageDetails.module.scss";

const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};

const handleOnClickCloneVersion = (navigate, packageGroupId, packageId) => {
  navigate(
    `/createPackageVersion?packageGroupId=${packageGroupId}&packageId=${packageId}`
  );
};

const handlePackageSelect = (package_group_id) => {
  const newUrl = `/packageDetails?packageGroupId=${package_group_id}`;
  window.location.href = newUrl;
};

const PackageDetails = () => {
  const [searchParams] = useSearchParams();
  const packageGroupId = searchParams.get("packageGroupId");
  const navigate = useNavigate();
  const [packageId, setPackageId] = useState(null);

  const {
    data: packageDetails,
    error: packageDetailsError,
    isLoading: isPackageDetailsLoading,
  } = usePackageDetails(packageGroupId);

  const {
    data: packageVersionDetails,
    isLoading: isPackageVersionDetailsLoading,
    error: packageVersionDetailsError,
  } = usePackageVersion(packageId);

  const activePackage = packageDetails?.active_package || (packageDetails?.versions?.[0] || null);

  const isActive = packageDetails?.active_package

  useEffect(() => {
    if (packageDetails) {
      const initialPackageId =
        packageDetails.active_package?.package_id ||
        packageDetails.versions?.[0]?.package_id ||
        null;
      setPackageId(initialPackageId);
    }
  }, [packageDetails]);

  const handleVersionChange = (packageId) => {
    setPackageId(packageId); 
  };

  if (isPackageDetailsLoading || isPackageVersionDetailsLoading) {
    return <Loader />;
  }

  if (packageDetailsError || packageVersionDetailsError) {
    return <div>Error loading package details. Please try again.</div>;
  }

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <div className={styles.searchPackageContainer}>
        <div className={styles.searchPackage}>
          <SearchPackage
            onPackageSelect={(pkg) =>
              handlePackageSelect(pkg.package_group_id)
            }
          />
        </div>
        <div className={styles.flexContainer}>
          <PrimaryButton
            onClick={() =>
              handleOnClickCloneVersion(navigate, packageGroupId, packageId)
            }
          >
            Clone Version
          </PrimaryButton>
        </div>
      </div>
      <SearchedPackageDetails
        packageDetails={packageVersionDetails || activePackage}
        onVersionChange={handleVersionChange}
        versions={packageDetails?.versions || []}
        isActive={isActive}
      />
    </div>
  );
};

export default PackageDetails;
